module.exports = __webpack_public_path__ + "img/a.cc84ccc0.png";